export enum Langs {
  RU = 'ru',
  KZ = 'kz',
}

export const LANGS = [
  { label: 'Русский', value: Langs.RU },
  { label: 'Казахский', value: Langs.KZ },
];
